import { Context } from '@nuxt/types';

export default function ({ store: { dispatch } }: Context) {
  return dispatch('VirtualOrderModule/getTotalAmount');
}
